<style scoped>
  #sidebar {
    position: fixed;
    right: 0;
    bottom: 100px;
    z-index: 1000;
    height:288px;
  }

  #sidebar p {
    padding-top: 50px;
    text-align: center;
    font-size: 14px;
    color: #868686;
  }

  #chat {
    width: 72px;
    height: 72px;
    background: #fafafa url(//v3.cdn.qiyewan.com/aside1.png) no-repeat center 14px;
    border: 1px solid #eee;
    position: relative;
  }

  #chat:hover #te_number {
    left: -152px;
    width: 143px;
  }

  #te_number {
    position: absolute;
    top: 11px;
    left: 0px;
    width: 0px;
    height: 72px;
    overflow: hidden;
    transition: 0.3s all ease-in-out;
  }

  #scan-qr-code {
    width: 72px;
    height: 72px;
    cursor: pointer;
    border: 1px solid #eee;
    background: #fafafa url(//v3.cdn.qiyewan.com/aside2.png) no-repeat center 14px;
    position: relative;
  }

  .line-service {
    width: 72px;
    height: 72px;
    cursor: pointer;
    background: #fafafa url(//v3.cdn.qiyewan.com/aside5.png) no-repeat center 14px;
    position: relative;
    border: 1px solid #eee;
  }

  #qr-code {
    position: absolute;
    top: 35px;
    left: 36px;
    height: 0;
    width: 0;
    opacity: 0;
    transition: 0.3s all ease-in-out;
    overflow: hidden;
  }

  #qr-code img {
    width: 100%;
    height: 100%;
  }

  #scan-qr-code:hover #qr-code {
    top: 9px;
    left: -147px;
    width: 140px;
    height: 132px;
    opacity: 1;
  }

  #scroll-to-top {
    width: 72px;
    height: 72px;
    cursor: pointer;
    border: 1px solid #eee;
    background: #fafafa url(//v3.cdn.qiyewan.com/aside4.png) no-repeat center 17px;
  }

  #newsicon {
    width: 72px;
    height: 72px;
    cursor: pointer;
    background: #fafafa url(//v3.cdn.qiyewan.com/aside3.png) no-repeat center 14px;
    position: relative;
    border: 1px solid #eee;
  }
  .kehkz {
    width: 72px;
    height: 72px;
    cursor: pointer;
    background: #fafafa url(//v3.cdn.qiyewan.com/aside6.png) no-repeat center 14px;
    position: relative;
    border: 1px solid #eee;
  }

  #share {
    width: 72px;
    height: 72px;
    cursor: pointer;
    border: 1px solid #eee;
    background: #fafafa url(//v3.cdn.qiyewan.com/aside2.png) no-repeat center 14px;
    position: relative;
  }
</style>
<style>
  .jiathis_style a span {
    margin-top: 0!important;
  }
</style>
<template>
  <div id="sidebar">
    <!--<div class="jiathis_share_slide jiathis_share_24x24" id="jiathis_share_slide">-->
      <!--<div class="jiathis_share_slide_top" id="jiathis_share_title"></div>-->
      <!--<div class="jiathis_share_slide_inner">-->
        <!--<div class="jiathis_style_24x24">-->
          <!--<a class="jiathis_button_qzone"></a>-->
          <!--<a class="jiathis_button_tsina"></a>-->
          <!--<a class="jiathis_button_weixin"></a>-->
          <!--<a href="http://www.jiathis.com/share" class="jiathis jiathis_txt jtico jtico_jiathis" target="_blank"></a>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
    <div class="kehkz">
      <a href="http://finance.qiyewan.com" target="_blank"><p>客户看账</p></a>
    </div>
    <div id="chat">
      <p>电话咨询</p>
      <div id="te_number">
        <img src="//v3.cdn.qiyewan.com/asidetel.png" alt="tel">
      </div>
    </div>
    <!--<div class="line-service" href="javascript:void(0)" onclick="_MEIQIA('showPanel')">-->
      <!--&lt;!&ndash;<div id="zhichiBtnBox" class="zhiCustomBtn line-service">&ndash;&gt;-->
      <!--<p>在线客服</p>-->
    <!--</div>-->
    <div id="scan-qr-code">
      <p>服务号</p>
      <div id="qr-code">
        <img src="//v3.cdn.qiyewan.com/asidema.png" alt="qrcode">
      </div>
    </div>
    <!--<div id="share">-->
      <!---->
    <!--</div>-->
    <div id="newsicon">
      <router-link to="/ArticleHome"><p>创业资讯</p></router-link>
    </div>
    <div id="scroll-to-top"
         v-bind:style="{ display: isTop ? 'none' : 'block' }"
         @click="handleScrollToTop()">
      <p>返回顶部</p>
    </div>
  </div>
</template>
<script>
  export default{
    data () {
      return {
        isTop: true,
        toTop: 0,
        winHeight: document.documentElement.clientHeight
      }
    },
    watch: {
      '$route' (to, from) {
//        this.loadJiaThis()
      },
    },
    methods: {
      loadJiaThis() {
//        let url = 'http://v3.jiathis.com/code/jiathis_r.js?move=0&amp;uid=2151962'
//        let script = document.createElement('script')
//        script.setAttribute('src', url)
//        document.getElementsByTagName('head')[0].appendChild(script)
      },
      handleScrollToTop () {
        let vm = this
        let timer = setInterval(function () {
          let speed = Math.ceil(vm.toTop / 15)
          document.documentElement.scrollTop = document.body.scrollTop = vm.toTop - speed
          if (vm.toTop === 0) {
            clearInterval(timer)
          }
        }, 10)
      },
      handleScroll () {
        this.toTop = document.body.scrollTop || document.documentElement.scrollTop
        this.isTop = this.toTop < this.winHeight
      },
      openService(){
      }
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll)
    },
    created() {
      // TODO 刷新页面时，jiathis无法显示
//      this.loadJiaThis()
    }
  }
</script>



// WEBPACK FOOTER //
// SideBar.vue?9159a5b8